import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useApi } from '@/hooks/use-api';
import { ymd, findLiveNow, kindCfg } from '@/lib/schedule';

/**
 * Header chip that only appears when a session/event is LIVE right now.
 * Clicking it jumps to that item's detail page. Re-checks every 30s.
 */
export const LiveNowChip = () => {
  const api = useApi();
  const [live, setLive] = useState(null);

  useEffect(() => {
    let active = true;
    const today = ymd(new Date());
    const check = () => {
      api.get(`/api/schedule?start=${today}&end=${today}`)
        .then((r) => { if (active) setLive(findLiveNow(r.items || [])); })
        .catch(() => { if (active) setLive(null); });
    };
    check();
    const t = setInterval(check, 30000);
    return () => { active = false; clearInterval(t); };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!live) return null;
  const to = kindCfg(live.kind).route(live) || '/app/calendar';

  return (
    <Link to={to} data-testid="live-now-chip" title={live.title}>
      <span className="hidden md:inline-flex items-center gap-1.5 rounded-full border border-destructive/40 bg-destructive/10 text-destructive font-grotesk uppercase text-[10px] tracking-wider px-2.5 py-1 hover:bg-destructive/15 transition-colors">
        <span className="h-1.5 w-1.5 rounded-full bg-destructive live-dot" /> Live Now
      </span>
    </Link>
  );
};

export default LiveNowChip;
